import moment from 'moment'
import groupby from 'lodash.groupby'
import { CadencierService } from '@/services/CadencierService'
import CommonUtils from '../utils/commonUtils'
import { NotilusService } from '@/services/NotilusService'

export const state = {
  loading: false,
  allDiff: [],
  diff: [],
  vbo: {},
  date: moment().format('YYYY-MM-DD'),
}

export const mutations = {
  setCadencierLoading(currentState, loading) {
    currentState.cadencier.loading = loading
  },
  setVBO(currentState, vbo) {
    currentState.cadencier.vbo = vbo.vbo
  },
  setCadencierDiff(currentState, cadencier) {
    currentState.cadencier.allDiff = cadencier.cadencier
    currentState.cadencier.diff = cadencier.diff
  },
  setCadencierDate(currentState, date) {
    currentState.cadencier.date = date
  },
}

export const actions = {

  setCadencierDate({ commit }, date) {
    commit('setCadencierDate', date)
  },
  loadVBO({ commit, getters }) {
    NotilusService.getVBO(getters.contextClientId).then(vbo => {
      commit('setVBO', { vbo })
    })
  },
  loadCadencierDiff({ commit }, { date }) {
    commit('setCadencierLoading', true)
    Promise.all([
      CadencierService.getCadencier(date),
      CadencierService.getAllCadencier(date),
    ]).then(cadenciers => {
      const grouped = groupby([...cadenciers[1]], 'plu')
      const filteredLines = Object.values(grouped).map(element => {
        if (element.length > 1) {
          return element.filter(el => !el.static)
        }
        return element
      })
      commit('setCadencierLoading', false)
      commit('setCadencierDiff', { diff: cadenciers[0], cadencier: CommonUtils.flatMap(filteredLines) })
    })
  },
}
export default {
  state, actions, mutations,
}
